import apiManagerRoom from 'api/manager-meeting'
import { DOMAIN_MEETING } from 'constants/api'
import { useCallback, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { openCalledRoom } from 'services/calledRoom'
import { setCloseDialogCC } from 'utils/helpers'

const useMeetingCC = () => {

    const { t } = useTranslation()
    const [isJoining, setIsJoining] = useState(false)
    const [joinError, setJoinError] = useState('')
    const joiningRef = useRef(false)

    const handleJoinID = async(type, roomId, setAnchorEl) => {
        if (type === "meet") {
            window.open(`${DOMAIN_MEETING}/${roomId}`, "_self")
            if(setAnchorEl) setAnchorEl(undefined)
            else setCloseDialogCC()
        } else {
            if (joiningRef.current) return

            joiningRef.current = true
            setIsJoining(true)
            setJoinError('')

            try {
                await openCalledRoom(typeof roomId === 'string' ? roomId.trim() : roomId, t('pgMeeting:immediatelyRoom'))
                if(setAnchorEl) setAnchorEl(undefined)
                else setCloseDialogCC()
            } catch (error) {
                setJoinError(error?.response?.data?.detail_err || error?.code || 'CALLED_ROOM_REQUEST_FAILED')
            } finally {
                joiningRef.current = false
                setIsJoining(false)
            }
        }
    }

    const clearJoinError = useCallback(() => setJoinError(''), [])

    return {
        handleJoinID,
        isJoining,
        joinError,
        clearJoinError
    }
}

export default useMeetingCC
